import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getContentDispositionFilename } from '../../../utils/getContentDispositionFilename'
import fileDownload from 'js-file-download'
import { getUrlWithVersion } from '../../../api/api'

export const downloadProductConfig = createAsyncThunk<
    void,
    { guid: string; configName: string },
    ThunkConfig<string>
>('productsSlice/downloadProductConfig', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid, configName } = args

    try {
        const response = await api.get(
            getUrlWithVersion(`/products/${guid}/configuration_file`),
            {
                responseType: 'blob',
                params: {
                    config_key: configName,
                },
            }
        )
        if (response.status === 200) {
            const filename = getContentDispositionFilename(response)
            fileDownload(response.data, filename)
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to download product config')
    }
})
